import React, { useRef, useEffect, useState } from 'react'
import { ActivityIndicator, StyleSheet } from 'react-native'
import SessionManager from 'APP/NativeModules/SessionManager'

import { Colors } from 'APP/Themes'
import { VideoContainer } from './Container'

interface PublisherViewProps {
  isMuted: boolean
  isCameraOff?: boolean
  sessionId?: string | null
}

const PublisherView: React.FC<PublisherViewProps> = ({ isMuted }) => {
  const videoWrapper = useRef<HTMLDivElement>(null)

  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (videoWrapper.current) {
      SessionManager.publish().then((videoElement: HTMLVideoElement) => {
        if (videoElement?.style) {
          videoElement.style.width = '100%'
          videoElement.style.height = '100%'
          videoElement.style.objectFit = 'cover'
        }
        videoElement.addEventListener('loadeddata', () => setIsReady(true))
        const wrapper = videoWrapper.current
        if (typeof wrapper?.appendChild === 'function') {
          wrapper.appendChild(videoElement)
        }
      })
    }
    return () => {
      SessionManager.unpublish()
    }
  }, [])

  useEffect(() => {
    SessionManager.mutePublisher(isMuted)
  }, [isMuted])

  return (
    <>
      <VideoContainer data-testid="publisher-video" ref={videoWrapper as never} isReady={isReady} />
      {!isReady && (
        <ActivityIndicator
          testID="publisher-loading"
          color={Colors.videoBorder}
          animating
          size="large"
          style={StyleSheet.absoluteFill}
        />
      )}
    </>
  )
}

export default PublisherView
